import { render, staticRenderFns } from "./reOrderPara.vue?vue&type=template&id=6292225f&scoped=true&"
import script from "./reOrderPara.vue?vue&type=script&lang=js&"
export * from "./reOrderPara.vue?vue&type=script&lang=js&"
import style0 from "./reOrderPara.vue?vue&type=style&index=0&id=6292225f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6292225f",
  null
  
)

export default component.exports